module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: (_vm.scrollPos),
      expression: "scrollPos"
    }],
    staticClass: "page-landing"
  }, [_c('hotlink-section'), _vm._v(" "), _c('about-section'), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0"
    },
    attrs: {
      "id": "section-show",
      "height": "0"
    }
  }), _vm._v(" "), _c('instagram-section', {
    attrs: {
      "id": "photos-official",
      "data-aos": "fade-in",
      "data-aos-once": "true"
    },
    on: {
      "onItemClick": _vm.onDialogPhoto
    }
  }), _vm._v(" "), _c('sponsors-section'), _vm._v(" "), _c('base-dialog', {
    attrs: {
      "visible": _vm.dialogPhotoVisible,
      "no-footer": true
    },
    on: {
      "onClose": _vm.onCloseDialogPhoto
    }
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": (_vm.dialogPhoto.image && _vm.dialogPhoto.image.path ? _vm.dialogPhoto.image.path : (_vm.dialogPhoto.type === 'VIDEO' ? _vm.dialogPhoto.url2 : _vm.dialogPhoto.url)),
      "alt": "Image"
    }
  })])]), _vm._v(" "), (false) ? _c('vm-back-top', {
    attrs: {
      "bottom": 45,
      "right": 25,
      "duration": 1000,
      "timing": 'ease'
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span')])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b065bdd8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Landing.vue
// module id = 933
// module chunks = 1